export default "__VITE_ASSET__c0a13864__$_?component__"